export default __webpack_public_path__ + "static/media/when-604.5302e13a.mp3";